import React, { useState } from "react";
import { pagetypeActions } from "../../actions";
import { connect } from "react-redux";

function AddGroupModal(props) {
  const { org_id, handleClose, createPageGroup, getPageGroups } = props;

  const [newGroupName, setNewGroupName] = useState("");
  const [pageGroup, setPageGroup] = useState({});

  const setGroupName = (e) => {
    const { name, value } = e.target;
    setNewGroupName(value);
  };

  const submitRequest = (e) => {
    e.preventDefault();
    pageGroup["org_id"] = org_id;
    pageGroup["page_group_name"] = newGroupName;
    createPageGroup(pageGroup);
    handleClose();
  };

  return (
    <div className="addGroupModal">
      <div className="modal-container">
        <form class="ingestorForm">
          <span class="addGroupSpan" onClick={handleClose}>
            X
          </span>
          <table class="ingestorFormTable">
            <tr>
              <td>&nbsp;</td>
              <td class="formInfo">Add Group</td>
            </tr>
            <tr>
              <td colspan="2">
                <hr />
              </td>
            </tr>
            <tr>
              <td class="formLabel">
                <label for="limit">Name:</label>
              </td>
              <td class="formInfo">
                <input
                  type="text"
                  size="32"
                  name="groupName"
                  id="groupName"
                  onChange={setGroupName}
                ></input>
              </td>
            </tr>
            <tr>
              <td class="formLabel">&nbsp;</td>
              <td class="formInfo">
                <button class="submit" onClick={submitRequest}>
                  Submit
                </button>
              </td>
            </tr>
          </table>
        </form>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  const { authentication, pagetypes } = state;
  return {
    authentication,
    pagetypes,
  };
}

const actionCreators = {
  createPageGroup: pagetypeActions.createPageGroup,
  getPageGroups: pagetypeActions.getPageGroups,
};
const connectedAddGroupModal = connect(
  mapStateToProps,
  actionCreators
)(AddGroupModal);

export { connectedAddGroupModal as AddGroupModal };
